<a routerLink="/" title="Accueil" class="brand">
  <div class="brand-name">
    <span class="perval">Perval</span>
    <span class="brand-region">.fr</span>
  </div>
  <p class="brand-slogan">Les références immobilières du Notariat</p>
</a>
